var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('router-view')],1),(_vm.$route.path!='/c/dashboard' && _vm.$route.path!='/c/incident' && _vm.$route.path!='/c/incident/create')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }